var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportCsv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_201_11655)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6468 5.01339L12.8432 0.209821C12.7093 0.0758929 12.5285 0 12.3388 0H2.85662C2.46153 0 2.14233 0.319196 2.14233 0.714286V19.2857C2.14233 19.6808 2.46153 20 2.85662 20H17.1423C17.5374 20 17.8566 19.6808 17.8566 19.2857V5.52009C17.8566 5.33036 17.7807 5.14732 17.6468 5.01339ZM16.2093 5.84821H12.0084V1.64732L16.2093 5.84821ZM16.2495 18.3929H3.74948V1.60714H10.4905V6.42857C10.4905 6.67721 10.5893 6.91567 10.7651 7.09148C10.941 7.2673 11.1794 7.36607 11.428 7.36607H16.2495V18.3929ZM10.0464 11.5201L8.66689 9.23438C8.61778 9.15402 8.53073 9.10491 8.43698 9.10491H7.57983C7.5285 9.10491 7.47939 9.1183 7.43698 9.14732C7.31198 9.22545 7.27403 9.39062 7.35439 9.51786L9.19144 12.4286L7.32983 15.3929C7.30454 15.4335 7.29057 15.4802 7.28936 15.5281C7.28816 15.5759 7.29976 15.6232 7.32298 15.6651C7.34619 15.707 7.38018 15.7419 7.42141 15.7663C7.46264 15.7906 7.50963 15.8035 7.55751 15.8036H8.3276C8.42135 15.8036 8.50617 15.7545 8.55528 15.6763L9.95483 13.4107L11.3455 15.6741C11.3946 15.7545 11.4816 15.8013 11.5731 15.8013H12.4102C12.4615 15.8013 12.5106 15.7857 12.5553 15.7589C12.6803 15.6786 12.716 15.5134 12.6356 15.3884L10.7606 12.4777L12.6647 9.52009C12.6904 9.47955 12.7049 9.43285 12.7065 9.38484C12.7081 9.33683 12.6968 9.28927 12.6738 9.24711C12.6507 9.20495 12.6168 9.16972 12.5756 9.14511C12.5343 9.12049 12.4872 9.10738 12.4392 9.10714H11.6423C11.5486 9.10714 11.4615 9.15625 11.4124 9.23661L10.0464 11.5201Z",
    fill: "#263668"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_201_11655"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportCsv);
export default __webpack_public_path__ + "static/media/export-csv.b56f7cef592aa7b6cf7e1f38ddb12696.svg";
export { ForwardRef as ReactComponent };